import { SkeletonPlaceholder } from '@yembo/yemblocks-core';

export const LoadingAnimation = () => (
  <div className='loading-skeleton'>
    <SkeletonPlaceholder className='loading-skeleton-header' />
    <div className='loading-skeleton-body'>
      <SkeletonPlaceholder className='loading-skeleton-sidebar' />
      <SkeletonPlaceholder className='loading-skeleton-content' />
    </div>
  </div>
);
